import { SeasonDashboard } from "@/components/SeasonDashboard"

export function SeasonsPage() {
  return <SeasonDashboard />
}
